export default __webpack_public_path__ + "static/media/image-svgrepo-com.1573ec2b.svg";